import { formatTanggalPendek } from "@/lib/datetime";
import { KOLOM_RINCIAN, LABEL_KATEGORI, teksSelisihHari } from "@/lib/sinkronStase";

const angka = (n) => Number(n || 0).toLocaleString("id-ID");

function TabelRincian({ judul, kolomPertama, baris, kunci, label, tambahan = [] }) {
    if (!baris.length) return null;
    const kolom = [...KOLOM_RINCIAN, ...tambahan];
    return (
        <div>
            <div className="text-xs font-semibold text-slate-700 mb-1">{judul}</div>
            <div className="overflow-x-auto rounded border border-slate-200">
                <table className="w-full text-xs">
                    <thead className="bg-slate-50 text-slate-600">
                        <tr>
                            <th className="text-left font-semibold px-2 py-1.5 whitespace-nowrap">{kolomPertama}</th>
                            {kolom.map(([k, l]) => <th key={k} className="text-right font-semibold px-2 py-1.5 whitespace-nowrap">{l}</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {baris.map((b) => (
                            <tr key={kunci(b)} className="border-t border-slate-200">
                                <td className="px-2 py-1.5 text-slate-800">{label(b)}</td>
                                {kolom.map(([k]) => <td key={k} className="px-2 py-1.5 text-right text-slate-700">{angka(b[k])}</td>)}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

// Hasil GET /sinkron-stase/pratinjau: angka per kategori, jenjang, dan prodi (tanpa nama peserta).
export default function SinkronStasePratinjau({ data }) {
    return (
        <div className="space-y-3 border-t border-slate-200 pt-3" data-testid="sinkron-stase-hasil">
            <div className="text-xs text-slate-500">Pratinjau tanggal {formatTanggalPendek(data.tanggal)}. Tidak ada data yang diubah.</div>
            <div className="overflow-x-auto rounded border border-slate-200">
                <table className="w-full text-xs">
                    <tbody>
                        {LABEL_KATEGORI.map(([k, l]) => (
                            <tr key={k} className="border-t first:border-t-0 border-slate-200">
                                <td className="px-2 py-1.5 text-slate-700">{l}</td>
                                <td className="px-2 py-1.5 text-right font-semibold text-slate-900" data-testid={`sinkron-stase-${k}`}>{angka(data.total[k])}</td>
                            </tr>
                        ))}
                        <tr className="border-t border-slate-200">
                            <td className="px-2 py-1.5 text-slate-700">Segmen Stase Luar tanpa tanggal lengkap (perlu dilengkapi sekre)</td>
                            <td className="px-2 py-1.5 text-right font-semibold text-slate-900" data-testid="sinkron-stase-segmen">{angka(data.segmen_luar_tanpa_tanggal)}</td>
                        </tr>
                        <tr className="border-t border-slate-200">
                            <td className="px-2 py-1.5 text-slate-700">Perkiraan selisih total hari Stase RSCM bulan berjalan</td>
                            <td className="px-2 py-1.5 text-right font-semibold text-slate-900 whitespace-nowrap" data-testid="sinkron-stase-selisih">{teksSelisihHari(data.selisih_hari_rscm_bulan_ini)}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <TabelRincian judul="Per jenjang" kolomPertama="Jenjang" baris={data.per_jenjang} kunci={(b) => b.jenjang} label={(b) => b.jenjang} />
            <TabelRincian judul="Per program studi" kolomPertama="Program Studi" baris={data.per_prodi} kunci={(b) => b.prodi_id}
                label={(b) => `${b.nama_prodi}${b.jenjang ? ` (${b.jenjang})` : ""}`}
                tambahan={[["segmen_luar_tanpa_tanggal", "Luar tanpa tanggal"]]} />
        </div>
    );
}
